export default class BasicControl {
  constructor(options = {}) {
    this._buttonHtmlContent = options.buttonHtmlContent;
    this._title = options.title;
    this._onClick = options.onClick;
  }

  onAdd(map) {
    this._map = map;
    this._btn = document.createElement("button");
    this._btn.innerHTML = this._buttonHtmlContent;
    this._btn.type = "button";
    this._btn.title = this._title;
    this._btn.addEventListener("click", this._onClick);

    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  enable() {
    this._btn.disabled = false;
  }

  disable() {
    this._btn.disabled = true;
  }
}
